import { inject } from '@angular/core';
import { CanActivateFn, Router } from '@angular/router';
import { map, take } from 'rxjs/operators';
import { JwtService } from '@app/core/auth';

export const adminGuard: CanActivateFn = () => {
  const jwt = inject(JwtService);
  const router = inject(Router);
  return jwt.isAdmin$.pipe(
    take(1),
    map(isAdmin => isAdmin ? true : router.parseUrl('/unauthorized')),
  );
};
